function canvasToFile(
  canvas: HTMLCanvasElement,
  type: string,
  filename: string,
  quality?: number,
): Promise<File> {
  return new Promise((resolve) => {
    canvas.toBlob(
      (blob) => {
        const file = new File([blob || new Blob()], filename, {type: type});
        resolve(file);
      },
      type,
      quality,
    );
  });
}

export default canvasToFile;
